import {
    REQUEST_SHIPMENTS_PROBLEM,
    REQUEST_SHIPMENTS_PROBLEM_FAILURE,
    REQUEST_SHIPMENTS_PROBLEM_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";

const initialState = {
    shipmentsProblem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const shipmentsProblemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SHIPMENTS_PROBLEM:
            return {
                ...state,
                shipmentsProblem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SHIPMENTS_PROBLEM_SUCCESS:
            return {
                ...state,
                shipmentsProblem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SHIPMENTS_PROBLEM_FAILURE:
            return {
                ...state,
                shipmentsProblem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
